const Promise = require('bluebird');
const uuid = require('uuid');

const Reflux = require('@muzzylane/reflux');
const _ = {
    cloneDeep: require('lodash/cloneDeep'),
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    once: require('lodash/once'),
};

const Globals = require('../../../app/globals');
const Strings = require('../../../app/shared/Strings');

const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');

const VoiceActions = require('../actions/VoiceActions');

const INIT_VOICE_ENGINES = [
    // AWS Polly
    {system: Globals.VOICE_SYSTEMS.POLLY,   engine: "standard",    displayName: "Standard",    voices:[] },
    {system: Globals.VOICE_SYSTEMS.POLLY,   engine: "neural",      displayName: "Neural",      voices:[] },
    {system: Globals.VOICE_SYSTEMS.POLLY,   engine: "generative",  displayName: "Generative",      voices:[] },
    
    // ElevenLabs
    {system: Globals.VOICE_SYSTEMS.ELEVENLABS,  engine: Globals.ELEVENLABS_ENGINES[0],    displayName: Strings['en'].ELEVENLABS_ENGINES[Globals.ELEVENLABS_ENGINES[0]],    voices:[] },
    {system: Globals.VOICE_SYSTEMS.ELEVENLABS,  engine: Globals.ELEVENLABS_ENGINES[1],    displayName: Strings['en'].ELEVENLABS_ENGINES[Globals.ELEVENLABS_ENGINES[1]],    voices:[] },

    // Cartesia
    {system: Globals.VOICE_SYSTEMS.CARTESIA,  engine: Globals.CARTESIA_ENGINES[0],    displayName: Strings['en'].CARTESIA_ENGINES[Globals.CARTESIA_ENGINES[0]],    voices:[] },

];
let DEFAULT_OPTIONS = {
    volume: 100,
    disabled: false
};

// data in this store
let action = {};
let VOICE_ENGINES = _.cloneDeep(INIT_VOICE_ENGINES);
let voicesRequested = false;
let voiceElement = {
    // mounted: false,  // state from voice audio element (deprecated property)
    // start: false,    // state from voice audio element (deprecated property)
    // stop:false       // state from voice audio element (deprecated property)
    // paused: false,     // command to voice audio element
};

let options = _.cloneDeep(DEFAULT_OPTIONS);
let channelUsage = {};

const VoiceSystem = require('../util/VoiceSystem');

const VoiceStore = Reflux.createStore({
    listenables: [VoiceActions],
    init: () => { return; },

    resetState: function() {
        voicesRequested = false;
        VOICE_ENGINES = _.cloneDeep(INIT_VOICE_ENGINES);
        options = _.cloneDeep(DEFAULT_OPTIONS);
        voiceElement = {}; 
        channelUsage = {};
    },

    getState: function() {
        return {
            action,
            VOICE_ENGINES,
            options,
            voiceElement,
        };
    },
    
    getChannelState: function(channelId) {
        return {
            action,
            usage: channelUsage[channelId],
        }
    },
    
    getDataForVoiceSystem: function({fromConstructor, anonymous,hasPolly,hasElevenLabs, hasCartesia}) {
        let any_voices = false;
        let voices = {};
        let engines = [];
        for (var i in VOICE_ENGINES) {
            let engine_record = VOICE_ENGINES[i];
            if (((hasPolly && engine_record.system === Globals.VOICE_SYSTEMS.POLLY)) ||
                ((hasElevenLabs && engine_record.system === Globals.VOICE_SYSTEMS.ELEVENLABS)) ||
                ((hasCartesia && engine_record.system === Globals.VOICE_SYSTEMS.CARTESIA))
                ) {
                engines.push({
                    system: engine_record.system,
                    engine: engine_record.engine,
                    displayName: engine_record.displayName
                });
                if (engine_record.voices && engine_record.voices.length) {
                    voices[engine_record.engine] = _.filter(engine_record.voices,(v)=>{ return v.disabled ? false : true }); // screen out disabled voices
                    any_voices = true;
                }
            }
        }
        if (!any_voices) {
            if (!fromConstructor && !voicesRequested) {
                // a template client has asked for the voice system, 
                // so we actually need the data.
                VoiceActions.getVoices(uuid.v4(),{anonymous,polly:hasPolly,elevenlabs:hasElevenLabs,cartesia:hasCartesia});
            }
            return {
                voices: null,
                engines: null,
            }
        }
        return {voices, engines};
    },
    
    // return VoiceSystem instance (provides iframe message handling for voice synthesis)
    getVoiceSystem: function(usage,params) {
        // usage = one of the SYSTEM_USAGE values
        // params: additional info depending on usage
        let hasPolly = false;
        let hasElevenLabs = false;
        let hasCartesia = false;
        if (params && params.userData) {
            if (params.userData.account_permissions && params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesis]) {
                hasPolly = params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesis];
            }
            else if (params.userData.permissions && params.userData.permissions[Globals.users.account_features.useVoiceSynthesis]) {
                hasPolly = params.userData.permissions[Globals.users.account_features.useVoiceSynthesis];
            }
            
            if (params.userData.account_permissions && params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesisElevenLabs]) {
                hasElevenLabs = params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesisElevenLabs];
            }
            else if (params.userData.permissions && params.userData.permissions[Globals.users.account_features.useVoiceSynthesisElevenLabs]) {
                hasElevenLabs = params.userData.permissions[Globals.users.account_features.useVoiceSynthesisElevenLabs];
            }

            if (params.userData.account_permissions && params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesisCartesia]) {
                hasCartesia = params.userData.account_permissions[Globals.users.account_features.useVoiceSynthesisCartesia];
            }
            else if (params.userData.permissions && params.userData.permissions[Globals.users.account_features.useVoiceSynthesisCartesia]) {
                hasCartesia = params.userData.permissions[Globals.users.account_features.useVoiceSynthesisCartesia];
            }
        }
        else {
            console.log("getVoiceSystem not given userData");
        }
        const NOT_ALLOWED_DATA = { notAllowed: true };
        if (!(hasPolly ||hasElevenLabs)) {
            switch(usage) {
                case this.SYSTEM_USAGE.ASSIGNMENT:
                case this.SYSTEM_USAGE.ACTIVITY_EDIT:
                case this.SYSTEM_USAGE.ACTIVITY_PREVIEW:
                case this.SYSTEM_USAGE.SHARE_LINK:
                    //if (params && params.userData && params.userData.admin) {
                    //    break; // allow muzzy lane internal use in editor
                    //}
                    return new VoiceSystem(NOT_ALLOWED_DATA);
                    
                case this.SYSTEM_USAGE.SHORT_COURSE_PLAY:
                    break; // always allowed
                    
                default:
                    return new VoiceSystem(NOT_ALLOWED_DATA);
            }
        }
        
        let anonymous = false;
        let {channelId, activityId, shareId, shortCourseId } = params.userData;
        if (usage === this.SYSTEM_USAGE.SHARE_LINK) {
            anonymous = true;
        }
        if (!channelId) {
            console.log("getVoiceSystem missing channelId"); // FIXME: remove debug spam
        }
        else {
            if (!activityId && !shortCourseId) {
                console.log("getVoiceSystem missing activityId or shortCourseId"); // FIXME: remove debug spam
            }
        }

        let { voices, engines } = this.getDataForVoiceSystem({fromConstructor:true, anonymous,hasPolly,hasElevenLabs,hasCartesia});
        
        // create a new VoiceSystem (to be owned by the caller)
        return new VoiceSystem({
            vs_funcs: {
                engines, voices,
                static_url: VoiceStore.synthesizeAudio,
                stream_url: Promise.method(VoiceStore.getStreamUrl),
            },
            anonymous, // used to determine which endpont to call
            hasPolly,
            hasElevenLabs,
            hasCartesia,
            channelId : channelId || null, 
            activityId : activityId || null, 
            shareId: shareId || null, // to track usage
            shortCourseId: shortCourseId || null,
        });
    },
    
    getVoicesForEngine: function(engine) {
        if (engine === 'elevenlabs') {
            engine = Globals.ELEVENLABS_ENGINES[0]; // all elevenlabs engines use the same voices, so we can just pick the first one
        }
        else if (engine == 'cartesia') {
            engine = Globals.CARTESIA_ENGINES[0]; // all cartesia engines are presumed to use the same voices, so we can just pick the first one
        }
        let ve = _.find(VOICE_ENGINES,{engine});
        if (ve) {
            return ve.voices;
        }
    },
    
    // what is using the voice role?
    SYSTEM_USAGE: Globals.SYSTEM_USAGE,

    // returns a persistent url for an audio file 
    // or an empty string if the audio is still being created
    // params: { engine, voice_id, phrase }
    synthesizeAudio: Promise.method(function(params) {
        if (!params.phrase) {
            return ''; // no audio for blanks
        }
        if (params.phrase.indexOf('{') >= 0) {
            console.log("synthesizeAudio: variable not parsed?",params); // FIXME: remove debug spam
        }
        if (params.usageData) {
            let { channelId, activityId, shareId, shortCourseId } = params.usageData;
            if (!channelId) {
                console.log("synthesizeAudio missing channelId"); // FIXME: remove debug spam
            }
            else if(!activityId && !shortCourseId) {
                console.log("synthesizeAudio missing activityId or shortCourseId"); // FIXME: remove debug spam
            }
        }
        else {
            console.log("synthesizeAudio missing usageData");
        }
        
        if (params.dynamic && !Globals.canStreamAndSave(params.engine)) {
            return ''; // can't be cached for this engine, so don't bother asking.  The caller will stream it
        }
        let url = params.anonymous ? `/authoring/synthesize_audio_anon`: `/authoring/synthesize_audio`
        if (params.dynamic) {
            url += '/cached'; // older servers 404 here (treated as not cached) rather than starting a synthesis task
        }
        
        return new Promise((resolve, reject) => {
            $.ajax({
                url,
                type: 'POST',
                data: JSON.stringify(params),
                contentType: 'application/json',
            })
            .done((src) => { 
                if (src && (src[0] !== '/') && (src.indexOf('http') != 0) ) {
                    src = '//' + src;
                }
                resolve(src);
            })
            .fail((err) => {
                console.log(`synthesizeAudio error`, err);
                resolve('');
            });
        });
    }), // synthesizeAudio

    // returns a url for an audio file that can be streamed 
    getStreamUrl: function(params) {
        if (!params.phrase) {
            return ''; // no audio for blanks
        }
        if (params.phrase.indexOf('{') >= 0) {
            console.log("getStreamUrl: variable not parsed?",params); // FIXME: remove debug spam
        }
        let {engine,voice_id,phrase,save} = params;
        if (!_.find(VOICE_ENGINES,{engine})) {
            console.error("getStreamUrl given bad engine:",engine);
            return null;
        }
        let synthPart = params.anonymous ? 'synthesize_audio_anon' : 'synthesize_audio';
        
        let url = `/authoring/${synthPart}/stream?e=${engine}&v=${voice_id}&t=${encodeURIComponent(phrase)}`;
        let { channelId, activityId, shareId, shortCourseId } = params.usageData;
        
        if (channelId) {
            url += `&ch=${channelId}`;
        }
        if (activityId) {
            url += `&act=${activityId}`;
        }
        if (shareId) {
            url += `&sh=${shareId}`;
        }
        if (shortCourseId) {
            url += `&sc=${shortCourseId}`;
        }
        if (save) {
            url += `&sv=1`;
        }
        
        return url;
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onError: function(actionId, err) {
        action.id = actionId;

        if (err && err.status) {
            switch (err.status) {
                case 400:
                case 403:
                case 406:
                    action.error = new ForgeError({message: err.responseText, stack: null});
                    break;
                    
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
            }
        }
        else {
            action.error = err || 'error';
        }

        this.emitStatus();
    },

    onGetVoicesRequested: function(actionId, all_voices) {
        voicesRequested = true;
    },

    onGetVoicesCompleted: function(actionId, all_voices) {
        action = { id : actionId };

        // VOICE_ENGINES = _.cloneDeep(INIT_VOICE_ENGINES); // keep the existing engines. Only replace the ones that were last requested
        let blanked = {};
        
        _.forEach(all_voices,(entry)=>{
            let { SupportedEngines,...theRest } = entry;
            _.forEach(SupportedEngines,(engine)=>{
                let engine_record = _.find(VOICE_ENGINES,{engine});
                if (engine_record) {
                    if (!blanked[engine]) {
                        blanked[engine] = true;
                        engine_record.voices = [];
                    }
                    engine_record.voices.push(theRest);
                }
            });
        });
        
        this.emitStatus();
    },

    onGetVoicesFailed: function(actionId, err) {
        console.warn("onGetVoicesFailed: ", actionId, err);
        this.onError(actionId, err);
    },
    
    onSetVoiceOptionsCompleted: function(actionId, _options) {
        action = { id: actionId, type: 'setVoiceOptions' };
        options = _options;
        // console.log("voice options changed to " + JSON.stringify(options));
        this.emitStatus();
    },
    
    onSetVoiceOptionsFailed: function(actionId, err) {
        console.warn("onSetVoiceOptionsFailed: ", actionId, err);
        this.onError(actionId, err);
    },

//    onSetVoiceElementMountedCompleted: function(mounted) {
//        action = { id: 'mounted' };
//        voiceElement.mounted = mounted;
//        this.emitStatus();
//    },

    onSetVoiceElementPlayCompleted: function(actionId, play) {
        action = { id: actionId, type: 'setVoiceElementPlay' };
        voiceElement.paused = !play;
        this.emitStatus();
    },

//    onSetVoiceElementStartStopCompleted: function(actionId,objStartStop) {
//        action = { id: actionId, type: 'setVoiceElementStartStop' };
//        voiceElement.start = !!objStartStop.start;
//        voiceElement.stop = !!objStartStop.stop;
//        this.emitStatus();
//    },


    onAdminGetChannelUsageCompleted: function(actionId, channelId, res) {
        action = { id: actionId, type: 'adminGetChannelUsage' };
        channelUsage[channelId] = res;
        this.emitStatus();
        
    },
    onAdminGetChannelUsageFailed: function(actionId, channelId, err) {
        console.warn("onAdminGetChannelUsageFailed: ", actionId,channelId, err);
        this.onError(actionId, err);
    },
    
    onAdminSetVoiceIdDisabledCompleted: function(actionId, res) {
        action = { id: actionId, type: 'adminGetChannelUsage' };
        let { engine, voice_id, disable } = res;
        if (typeof disable === 'string') {
            switch(disable) {
                case "true":
                    disable = true;
                    break;
                case "false":
                    disable = false;
                    break;
                default:
                    console.warn(`error converting ${disable} to boolean`);
            }
        }
        let engines = [engine];
        if (engine === 'elevenlabs') {
            engines = Globals.ELEVENLABS_ENGINES;
        }
        else if (engine == 'cartesia') {
            engines = Globals.CARTESIA_ENGINES;
        }
        
        _.forEach(engines,(engine)=>{
            let eri = _.findIndex(VOICE_ENGINES,{engine});
            let engine_record = VOICE_ENGINES[eri];
            if (engine_record) {
                let vi = _.findIndex(engine_record.voices,{Id: voice_id});
                let voice = engine_record.voices[vi];
                if (voice) {
                    voice.disabled = disable;
                    // mutate up the tree for react state update
                    engine_record.voices[vi] = voice;
                    engine_record.voices = engine_record.voices.slice();
                    VOICE_ENGINES[eri] = {...engine_record};
                }
                else {
                    console.warn(`AdminSetVoiceIdDisabled did not find engine ${engine} voice_id ${voice_id}`);
                }
            }
            else {
                console.warn(`AdminSetVoiceIdDisabled did not find engine ${engine}`);
            }
        });
        this.emitStatus();
    },
    onAdminSetVoiceIdDisabledFailed: function(actionId, err) {
        console.warn("onAdminSetVoiceIdDisabledFailed: ", actionId, err);
        this.onError(actionId, err);
    },
    
    onAdminSetVoiceIdCategoriesCompleted: function(actionId, res) {
        action = { id: actionId, type: 'adminGetChannelUsage' };
        let { engine, voice_id, categories } = res;
        if (typeof categories === 'string') {
            try {
                categories = JSON.parse(categories);
            }
            catch(e) {
                console.warn(`error converting ${categories} to object`,e);
                categories = {};
            }
        }
        let engines = [engine];
        if (engine === 'elevenlabs') {
            engines = Globals.ELEVENLABS_ENGINES;
        }
        else if (engine == 'cartesia') {
            engines = Globals.CARTESIA_ENGINES;
        }
        
        _.forEach(engines,(engine)=>{
            let eri = _.findIndex(VOICE_ENGINES,{engine});
            let engine_record = VOICE_ENGINES[eri];
            if (engine_record) {
                let vi = _.findIndex(engine_record.voices,{Id: voice_id});
                let voice = engine_record.voices[vi];
                if (voice) {
                    voice.categories = categories;
                    // mutate up the tree for react state update
                    engine_record.voices[vi] = voice;
                    engine_record.voices = engine_record.voices.slice();
                    VOICE_ENGINES[eri] = {...engine_record};
                }
                else {
                    console.warn(`AdminSetVoiceIdCategories did not find engine ${engine} voice_id ${voice_id}`);
                }
            }
            else {
                console.warn(`AdminSetVoiceIdCategories did not find engine ${engine}`);
            }
        });
        this.emitStatus();
    },
    onAdminSetVoiceIdCategoriesFailed: function(actionId, err) {
        console.warn("onAdminSetVoiceIdCategoriesFailed: ", actionId, err);
        this.onError(actionId, err);
    },


});

module.exports = VoiceStore;